import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";

const PersonalInfo = () => {
  const { user, setUser } = useAuth();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    gender: "Male",
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        gender: user.gender || "Male",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSave = async () => {
  try {
    const res = await axios.post(
      "https://mediapi.onlinepharmaque.in/api/v1/updateProfile",
      {
        userId: user._id,
        ...formData,
      }
    );

    // 🔹 Email duplicate case (partial success)
    if (res.data.emailError) {
      setUser(res.data.user);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      alert("Email already exists. Other profile details updated ✅");
      return;
    }

    // 🔹 Normal success
    if (res.data.success) {
      setUser(res.data.user);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      alert("Profile Updated Successfully ✅");
      return;
    }

    // 🔹 Fallback (rare case)
    alert("Profile update failed ❌");

  } catch (err) {
    console.error(err);

    // 🔹 Safety message
    alert(err.response?.data?.message || "Profile update failed ❌");
  }
};




  return (
    <div className="bg-white rounded-2xl p-8 max-w-2xl shadow">
      <h2 className="text-2xl font-semibold mb-8 text-teal-700">
        Personal Info
      </h2>

      {/* Gender */}
      <div className="flex gap-6 mb-8">
        {["Male", "Female"].map((g) => (
          <button
            key={g}
            onClick={() => setFormData({ ...formData, gender: g })}
            className={`w-28 h-28 rounded-xl border-2 flex flex-col items-center justify-center
              ${
                formData.gender === g
                  ? "border-teal-600 text-teal-700"
                  : "border-gray-300 text-gray-400"
              }`}
          >
            👤
            <span className="mt-2">{g}</span>
          </button>
        ))}
      </div>

      <input
        name="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email"
        className="w-full border rounded-lg px-4 py-3 mb-4"
      />

      <input
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        placeholder="Phone"
        className="w-full border rounded-lg px-4 py-3 mb-4"
      />

      <input
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="Full Name"
        className="w-full border rounded-lg px-4 py-3 mb-8"
      />

      <button
  type="button"   // ⭐ MUST
  onClick={handleSave}
  className="bg-teal-700 hover:bg-teal-800 text-white px-16 py-3 rounded-full text-lg"
>
  Save
</button>

    </div>
  );
};

export default PersonalInfo;

